import React from 'react';

export function HealthBar({ hp, maxHp, block = 0, side = 'player', testid }) {
  const pct = Math.max(0, Math.min(100, (hp / maxHp) * 100));
  const color = side === 'player' ? '#39ff14' : '#ff2b2b';
  return (
    <div data-testid={testid}>
      <div className="hpbar" style={{ borderColor: side === 'player' ? '#39ff14' : '#ff2b2b' }}>
        <div className="hpbar-fill" style={{ width: `${pct}%`, background: color }} />
        <div className="hpbar-text">{hp} / {maxHp}</div>
      </div>
      {block > 0 && (
        <div className="mt-1 flex items-center gap-2">
          <span className="buff-badge block" data-testid={`${testid}-block`}>◈ BLOCK {block}</span>
        </div>
      )}
    </div>
  );
}
